

import state from './moduleNewsState.js'
import mutations from './moduleNewsMutations.js'
import actions from './moduleNewsActions.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
